module.exports = __webpack_public_path__ + "img/b-3.47eff4d2.png";